import React from 'react';
import Spinner from '../Spinner';

interface GlobalLoaderProps {}

const GlobalLoader: React.FC<GlobalLoaderProps> = () => {
  return (
    <div className="blockUI blockOverlay global-loader">
      <Spinner variant="primary" className="position-fixed top-50 left-50" />
    </div>
  );
};

export default GlobalLoader;
